import React, { useState } from 'react';
import styled from 'styled-components';
import { ACCENT_COLOR, BTN, NAME_SECTION, PADDING, FONTSIZETITLE } from '../styles/style';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';


const FormWrapper = styled.div`
  background-color: #2b2f35;
  padding: 22px;
  @media(min-width: 768px){
    padding:40px;
  }
  border-radius: 10px;
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  color: white;
`;

const Title = styled.h2`
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-weight: 600;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 15px;
  border-radius: 8px;
  background-color: #1f2328;
  border: none;
  color: white;
  font-size: 1rem;

  &::placeholder {
    color: #888;
  }

  &:focus {
    outline: 2px solid #00c896;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 15px;
  border-radius: 8px;
  background-color: #1f2328;
  border: none;
  color: white;
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;

  &::placeholder {
    color: #888;
  }

  &:focus {
    outline: 2px solid #00c896;
  }
`;

const SubmitButton = styled.button`
  ${BTN};
`;

const Section = styled.section`
  ${PADDING};
  background-color: #343a40;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  position: relative;
`;

const AnimatedText = styled(motion.div)`
  width: 100%;
  max-width: 1300px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;

  .title {
    position: relative;
    color: white;
    width: 100%;
    ${FONTSIZETITLE};

    &::after {
      color: #ffffff60 !important;
      content: "KONTAKT";
      ${NAME_SECTION};
      width: 100%;
    }
  }

  .container-contact {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    flex-wrap: wrap;
    justify-content: center;
    gap: 60px;
     margin-top:60px;
    @media(min-width:768px){margin-top:100px;}
    margin-bottom: 60px;
    color: white;

    .info-contact {
      p {
        font-size: 1rem;
        text-align: center;
        color: #ffffff99;
        margin-top: 10px;
      }
    }
  }
`;

const Contact = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });

  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState({ loading: false, success: false, error: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: '' });

    try {
      const response = await fetch('https://wtalanda.pl/sendmail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      const result = await response.json();

      if (result.success) {
        setStatus({ loading: false, success: true, error: '' });
        setForm({ name: '', email: '', message: '' });
      } else {
        throw new Error(result.error || 'Nie udało się wysłać wiadomości.');
      }
    } catch (err) {
      setStatus({ loading: false, success: false, error: err.message });
    }
  };

  return (
    <Section id="contact" ref={ref}>
      <AnimatedText
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 1.2, ease: 'easeOut' }}
      >
        <div className="title">
          <h2>Skontaktuj się ze mną</h2>
        </div>

        <div className="container-contact">

          <FormWrapper>
            <Title>WYPEŁNIJ FORMULARZ</Title>
            <form onSubmit={handleSubmit}>
              <FormRow>
                <Input
                  name="name"
                  placeholder="Imię i nazwisko"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
                <Input
                  name="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={handleChange}
                  type="email"
                  required
                />
              </FormRow>
              <TextArea
                name="message"
                placeholder="Napisz wiadomość..."
                value={form.message}
                onChange={handleChange}
                required
              />
              <SubmitButton type="submit" disabled={status.loading}>
                {status.loading ? 'Wysyłanie...' : 'Wyślij wiadomość'}
              </SubmitButton>

              {status.success && <p style={{ color: ACCENT_COLOR, marginTop: 10 }}>Wiadomość wysłana!</p>}
              {status.error && <p style={{ color: 'red', marginTop: 10 }}>{status.error}</p>}
            </form>
          </FormWrapper>
        </div>
      </AnimatedText>
    </Section>
  );
};

export default Contact;
